import { render } from "./FormInvestment.vue?vue&type=template&id=7ec3b422&scoped=true"
import script from "./FormInvestment.vue?vue&type=script&lang=js"
export * from "./FormInvestment.vue?vue&type=script&lang=js"

import "./FormInvestment.vue?vue&type=style&index=0&id=7ec3b422&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec3b422"]])

export default __exports__